import React from 'react';
import type { OperationRunDetailsDto } from '../../types';
import { formatDateTime, formatDuration, parseJson, statusLabel, triggerLabel } from './utils.tsx';
import { getOperationExtension } from './operationExtensions';

interface Props {
    selectedRun: OperationRunDetailsDto | null;
}

const OperationRunLogPanel: React.FC<Props> = ({ selectedRun }) => {
    if (!selectedRun) return null;

    const extension = getOperationExtension(selectedRun.operationCode);
    const selectedReport = parseJson<Record<string, unknown>>(selectedRun.reportJson ?? null);
    const selectedSummary = parseJson<Record<string, unknown>>(selectedRun.summaryJson ?? null);
    const renderedReport = selectedReport ? extension?.renderReport?.(selectedReport) : null;

    return (
        <section className="operations-section">
            <div className="operations-run-details">
                <div><strong>Статус:</strong> {statusLabel[selectedRun.status] ?? selectedRun.status}</div>
                <div><strong>Триггер:</strong> {triggerLabel[selectedRun.trigger] ?? selectedRun.trigger}</div>
                <div><strong>Hangfire:</strong> {selectedRun.hangfireJobId ?? '-'}</div>
                <div><strong>Запустил:</strong> {selectedRun.requestedByUserName ?? '-'}</div>
                <div><strong>Начало:</strong> {formatDateTime(selectedRun.startedAt)}</div>
                <div><strong>Завершение:</strong> {formatDateTime(selectedRun.completedAt)}</div>
                <div><strong>Длительность:</strong> {formatDuration(selectedRun)}</div>
            </div>

            {selectedRun.parametersJson && selectedRun.parametersJson !== '{}' && (
                <div className="operations-param-block">
                    <h4>Параметры запуска</h4>
                    <pre className="operations-json">{selectedRun.parametersJson}</pre>
                </div>
            )}

            {selectedSummary && (
                <div className="operations-param-block">
                    <h4>Итог</h4>
                    <pre className="operations-json">{JSON.stringify(selectedSummary, null, 2)}</pre>
                </div>
            )}

            {selectedReport && (
                <div className="operations-param-block">
                    <h4>Отчет</h4>
                    {renderedReport ?? <pre className="operations-json">{JSON.stringify(selectedReport, null, 2)}</pre>}
                </div>
            )}

            <h4>События</h4>
            <div className="operations-log-list">
                {selectedRun.logs.length > 0 ? selectedRun.logs.map(log => (
                    <div className="operations-log-row" key={log.id}>
                        <span>{formatDateTime(log.createdAt)}</span>
                        <strong>{log.level}</strong>
                        <span>{log.message}</span>
                    </div>
                )) : (
                    <div className="operations-empty">Событий нет.</div>
                )}
            </div>
        </section>
    );
};

export default OperationRunLogPanel;
